import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { BUILD_ID } from "./build-id";

if (environment.production) {
	enableProdMode();
}

// DEV ONLY: start the login page fresh on each real `npm run start`, but NOT on
// the live-reloads that happen while you edit and save files.
//
// BUILD_ID is regenerated once per `npm run start` (via the prestart hook) and
// stays constant during a serve session (webpack's watch rebuilds don't re-run
// npm scripts). So a changed BUILD_ID = a genuine server (re)start -> clear the
// CAIRA session so we land on login; an unchanged BUILD_ID = a live-reload after
// a save -> keep the current session (no unwanted logout).
// NOTE: these keys must match CairaAuthService.
if (!environment.production) {
	const RUN_KEY = "caira_dev_build_id";
	// if (localStorage.getItem(RUN_KEY) !== BUILD_ID) {
	// 	[
	// 		"caira_access_token",
	// 		"caira_refresh_token",
	// 		"caira_user_id",
	// 		"caira_session",
	// 		"islogged_caira",
	// 	].forEach((key) => localStorage.removeItem(key));
	// 	localStorage.setItem(RUN_KEY, BUILD_ID);
	// }
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
